import { ReportData } from '../types/reportTypes';

// Parse currency string to number
const parseCurrency = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/[$,]/g, ''));
};

// Parse percentage string to number
const parsePercentage = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/%/g, '')) / 100;
};

// Calculate the sum of an array of numbers
const sum = (numbers: number[]): number => {
  return numbers.reduce((total, num) => total + num, 0);
};

// Calculate net profit and commission for Cody Cline reports
const calculateCodyNetProfit = (grossProfit: number, companyOH: number): number => {
  // For Cody Cline: Net Profit = Gross Profit - Company OH
  return grossProfit - companyOH;
};

const calculateCodyCommission = (netProfit: number): number => {
  // For Cody Cline: Sales Commission = 50% of Net Profit
  return netProfit / 2;
};

// Calculate the individual job data from the Cody Sales May CSV
const jobData = [// IMPORTANT: Using 13% flat OH calculation (Contract Total × 0.13) retroactive to 1/1/2025
  {
    jobInfo: "E-340: John Tustin",
    leadSource: "Referral- Dominic's network",
    trade: "Attic Insulation",
    contractTotal: 4590.00,
    grossMarginPct: 0.4089,
    grossProfit: 1876.85,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 4590.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-335: Xavier Briggs",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 2599.00,
    grossMarginPct: 0.6922,
    grossProfit: 1799.03,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2599.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-358: Joshua Wayne",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 18984.80,
    grossMarginPct: 0.4275,
    grossProfit: 8116.00,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 18984.80 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-355: Ballard Green Condo 2",
    leadSource: "Previous Customer",
    trade: "Roofing",
    contractTotal: 1100.00,
    grossMarginPct: 0.6364,
    grossProfit: 700.04,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1100.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-349: Bill Yeaton",
    leadSource: "Previous Customer",
    trade: "",
    contractTotal: 3799.00,
    grossMarginPct: 0.5995,
    grossProfit: 2277.50,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3799.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-336: Ellicott Hills Condo 1",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 1950.00,
    grossMarginPct: 0.6154,
    grossProfit: 1200.03,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1950.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-363: Christina Armas- Edwards",
    leadSource: "Referral- Cody's network",
    trade: "Windows",
    contractTotal: 12684.00,
    grossMarginPct: 0.4314,
    grossProfit: 5471.88,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 12684.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-380: Jim Alvarez",
    leadSource: "Previous Customer",
    trade: "Gutters",
    contractTotal: 17554.54,
    grossMarginPct: 0.3672,
    grossProfit: 6446.03,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 17554.54 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-382: Chris Meckel Dietrich Project",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 12808.00,
    grossMarginPct: 0.4324,
    grossProfit: 5538.18,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 12808.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-379: Lynne Weitz",
    leadSource: "Previous Customer",
    trade: "Attic insulation",
    contractTotal: 20298.10,
    grossMarginPct: 0.3526,
    grossProfit: 7157.11,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 20298.10 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "S-2799: Donald Vermillion",
    leadSource: "Site Survey Website",
    trade: "Solar Install",
    contractTotal: 30098.25,
    grossMarginPct: 0.3000,
    grossProfit: 9029.48,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 30098.25 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "S-2862: Jordan Gottlieb",
    leadSource: "Referral",
    trade: "Solar Install",
    contractTotal: 79100.00,
    grossMarginPct: 0.3000,
    grossProfit: 23730.00,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 79100.00 * 0.13, // 13% flat rate
    netProfit: 0
  }
];

// Apply business logic to calculate derived values
jobData.forEach(job => {
  // Calculate net profit using Cody's special rules
  job.netProfit = calculateCodyNetProfit(job.grossProfit, job.companyOH);
  
  // Calculate commission (50% of net profit for Cody)
  job.salesCommission = calculateCodyCommission(job.netProfit);
});

// Calculate totals
const totalContractValue = sum(jobData.map(job => job.contractTotal));
const totalGrossProfit = sum(jobData.map(job => job.grossProfit));
const totalCompanyOH = sum(jobData.map(job => job.companyOH));
const totalNetProfit = sum(jobData.map(job => job.netProfit));
const totalSalesCommissions = sum(jobData.map(job => job.salesCommission));

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade || 'Other';
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

// Export the final report data object
export const codyMayData: ReportData = {
  kpis: {
    // Set this to 0 for reports with no ad spend
    adSpend: 0,
    
    // Sum of all contract totals
    totalSales: totalContractValue,
    
    // Sum of all gross profits
    grossProfit: totalGrossProfit,
    
    // Sum of all sales commissions (50% of net profit for Cody)
    salesCommissions: totalSalesCommissions,
    
    // Sum of all manager fees (0 for Cody reports)
    managerFees: 0,
    
    // Company overhead 
    companyOH: totalCompanyOH,
    
    // Net profit based on Cody's calculation formula
    netProfit: totalNetProfit,
    
    // Net profit as percentage of total sales
    netProfitPercent: totalNetProfit / totalContractValue,
    
    // Gross profit as percentage of total sales
    grossProfitPercent: totalGrossProfit / totalContractValue
  },
  
  // Ad spend by source (empty array or with 0 values if no ad spend)
  adSpendBySource: [
    { source: "Previous Customer", spend: 0 },
    { source: "Referral", spend: 0 },
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 },
    { source: "Site Survey Website", spend: 0 }
  ],
  
  // Sales by lead source - aggregated above
  salesBySource: salesBySource,
  
  // Sales by trade - aggregated above
  salesByTrade: salesByTrade,
  
  // Individual job data
  jobData: jobData,
  
  // Report period information
  period: {
    month: 5, // May (1-12)
    year: 2025
  }
};